import { render, staticRenderFns } from "./ModalDownloadTurmasCursos.vue?vue&type=template&id=4479681f&scoped=true&"
import script from "./ModalDownloadTurmasCursos.vue?vue&type=script&lang=js&"
export * from "./ModalDownloadTurmasCursos.vue?vue&type=script&lang=js&"
import style0 from "./ModalDownloadTurmasCursos.vue?vue&type=style&index=0&id=4479681f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4479681f",
  null
  
)

export default component.exports